import React from 'react';

const SheetFooter = props => (<tfoot className="ant-table-tbody">
    <tr className="ant-table-row ant-table-row-level-0" colSpan={Object.keys(props.columns).length + (props.action ? 1 : 0)} style={{ height: '100px' }}>
        
    </tr>
</tfoot>);

export default SheetFooter;